import { NonEmptyArray } from "ts-essentials"
import { NUMERIC_OPERATORS, RangeNumberOperator, SingleNumberOperator } from "./numbers"

/* Types */
type ExistenceOperatorType = "hasValue" | "hasNoValue"

/* Formatters */
function trueFormatter(id: string, operator: ExistenceOperatorType) {
  return { [operator]: true }
}

/* Validators */
function alwaysValid(): true {
  return true
}

/* Operators */
interface ExistenceOperator {
  label: string
  value: ExistenceOperatorType
  queryFormatter: typeof trueFormatter
  validator: typeof alwaysValid
  selectorType: "none"
}

export const NUMERIC_AND_EXISTENCE_OPERATORS: NonEmptyArray<SingleNumberOperator | RangeNumberOperator | ExistenceOperator> = [
  ...NUMERIC_OPERATORS,
  {
    label: "has value",
    value: "hasValue",
    queryFormatter: trueFormatter,
    validator: alwaysValid,
    selectorType: "none",
  },
  {
    label: "has no value",
    value: "hasNoValue",
    queryFormatter: trueFormatter,
    validator: alwaysValid,
    selectorType: "none",
  },
] as const
